import SEO from '../components/SEO/SEO'
import TattooTherapy from '../components/TattooTherapy/TattooTherapy'
import Contact from '../components/Contact/Contact'

export default function TattooTherapyPage() {
  return (
    <>
      <SEO
        title="Tattoo Therapy Adelaide | Jesse B Tattoos"
        description="Tattoo Therapy with Jesse B Tattoos in Adelaide. A considered, personal approach for clients navigating grief, trauma, or meaningful life transitions."
        canonical="https://jessebtattoos.com/tattoo-therapy"
        keywords="tattoo therapy Adelaide, memorial tattoos Adelaide, meaningful tattoos, trauma tattoo support, Jesse B Tattoos"
        ogType="website"
      />
      <TattooTherapy />
      
    </>
  )
}